import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHome,
  faSearch,
  faBook,
  faUser,
  faBullhorn,
} from '@fortawesome/free-solid-svg-icons';
import '../../styles/UserProfile.css';

function navClass(isActive) {
  return isActive ? 'active' : '';
}

export default function AppSidebar() {
  const { currentUser } = useAuth();
  const { pathname } = useLocation();

  const isProfile =
    pathname.startsWith('/user/') || pathname === '/user-redirect';

  return (
    <aside className="tiktok-sidebar">
      <div className="tiktok-sidebar-inner">
      <Link to="/" className="tiktok-logo" aria-label="The Rise Network home">
        <span className="tiktok-brand-text">THE RISE NETWORK</span>
      </Link>

      {currentUser && (
        <Link to="/search" className="tiktok-search">
          <FontAwesomeIcon icon={faSearch} />
          <span>Search</span>
        </Link>
      )}

      <ul className="tiktok-nav">
        <li>
          <Link to="/" className={navClass(pathname === '/')}>
            <FontAwesomeIcon icon={faHome} />
            <span>Home</span>
          </Link>
        </li>
        {currentUser && (
          <li>
            <Link to="/home" className={navClass(pathname === '/home')}>
              <FontAwesomeIcon icon={faHome} />
              <span>Feed</span>
            </Link>
          </li>
        )}
        <li>
          <Link
            to="/subscription"
            className={navClass(pathname === '/subscription')}
          >
            <FontAwesomeIcon icon={faBook} />
            <span>Subscribe</span>
          </Link>
        </li>
        {currentUser ? (
          <li>
            <Link
              to="/bookcase"
              className={navClass(pathname.startsWith('/bookcase'))}
            >
              <FontAwesomeIcon icon={faBook} />
              <span>Bookcase</span>
            </Link>
          </li>
        ) : (
          <li>
            <Link
              to="/bookstore"
              className={navClass(pathname.startsWith('/bookstore'))}
            >
              <FontAwesomeIcon icon={faBook} />
              <span>Bookstore</span>
            </Link>
          </li>
        )}
        <li>
          <Link
            to={currentUser ? '/user-redirect' : '/login'}
            className={navClass(isProfile)}
          >
            <FontAwesomeIcon icon={faUser} />
            <span>Profile</span>
          </Link>
        </li>
        <li>
          <Link
            to="/advertise"
            className={navClass(pathname === '/advertise')}
          >
            <FontAwesomeIcon icon={faBullhorn} />
            <span>Advertise</span>
          </Link>
        </li>
      </ul>

      {!currentUser ? (
        <Link to="/login" className="tiktok-login-btn">
          Log in
        </Link>
      ) : (
        <Link
          to="/dashboard"
          className={`tiktok-login-btn tiktok-login-btn--secondary ${navClass(
            pathname === '/dashboard' || pathname === '/update-profile'
          )}`}
        >
          Account
        </Link>
      )}
      </div>
    </aside>
  );
}
